import { AnimatePresence } from 'framer-motion';
import { isEmpty, map } from 'lodash/fp';
import React from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';

import useMediaQuery from '@skippay/core/hooks/useMediaQuery';
import { media } from '@skippay/core/styles/media';
import { bm } from '@skippay/core/utils/classUtils';

import NotificationBox from 'components/NotificationBox';
import {
	SEVERITY_ERROR,
	SEVERITY_SUCCESS,
	SEVERITY_WARNING,
	destroyNotification,
	spawnedNotificationsSelector,
} from 'modules/notifications';

import './index.sass';

const MODULE_NAME = 'Notifications';
const PORTAL_ID = 'notifications-portal';

const Notifications = () => {
	const dispatch = useDispatch();
	const notifications = useSelector(spawnedNotificationsSelector);

	const isMobileResolution = useMediaQuery(media.lte('SM'));
	const isMobile = isMobileResolution || process.env.MOB_APP_BUILD;

	if (isEmpty(notifications)) {
		return null;
	}

	const notificationsContent = (
		<div className={bm(MODULE_NAME)}>
			<AnimatePresence>
				{map(({ content, id, severity, title }) => {
					return (
						<NotificationBox
							key={id}
							error={severity === SEVERITY_ERROR}
							success={severity === SEVERITY_SUCCESS}
							warning={severity === SEVERITY_WARNING}
							onClose={() => {
								dispatch(destroyNotification(id));
							}}
							title={title}
						>
							{content}
						</NotificationBox>
					);
				}, notifications)}
			</AnimatePresence>
		</div>
	);

	if (!isMobile) {
		return notificationsContent;
	}

	let portalContainer = document.getElementById(PORTAL_ID);
	if (!portalContainer) {
		portalContainer = document.createElement('div');
		portalContainer.id = PORTAL_ID;
		document.body.appendChild(portalContainer);
	}

	return createPortal(notificationsContent, portalContainer);
};

export default Notifications;
